<template>
  <div class="container">
    <selfcheck-loading-modal :visible="isLoading" />

    <div class="content">
      <div class="content-subject">{{ $t('selfcheck.failedToLoading') }}</div>
      <sorry-muten-image class="image" />
      <div class="content-text">{{ $t('selfcheck.selfcheckTryAgainApology') }}</div>
      <div class="content-button">
        <so-button class="cancel-button" @click="handleAbortSelfcheck">
          {{ $t('selfcheck.backToMainMenu') }}
        </so-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import SoButton from '@/components/common/SoButton.vue'
import SorryMutenImage from '@/components/images/SorryMutenImage.vue'
import SelfcheckLoadingModal from '@/components/modal/SelfcheckLoadingModal'

export default {
  components: {
    SoButton,
    SorryMutenImage,
    SelfcheckLoadingModal,
  },
  data() {
    return {
      isCanceled: false,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      isFetching: 'selfcheck/getIsFetching',
      error: 'selfcheck/getError',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  beforeRouteLeave(_to_, _from_, next) {
    if (!this.isCanceled) {
      next(false)
      return
    }
    next()
  },
  methods: {
    ...mapActions({
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async handleAbortSelfcheck() {
      await this.cancel(false)
    },
    async cancel(callStaff) {
      this.isLoading = true
      await this.cancelSelfcheck({ callStaff })

      if (!this.error) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      } else {
        this.isLoading = false
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
  },
  head: {
    title() {
      return {
        inner: this.$t('selfCheck.error'),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  display: flex;
  margin: 30px auto 0;
}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #fff;
  padding-bottom: 70px;
}
.content-subject {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.content-text {
  padding-top: 30px;
  font-size: 16px;
  font-weight: 400;
  white-space: pre-wrap;
}
.content-button {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  width: 100%;
}
.cancel-button {
  max-width: 240px;
  background-color: #333;
}
.quit-button {
  width: 240px;

  img {
    width: 18px;
    height: 18px;
    color: #fff;
    margin: 0 8px 0 0;
  }
}
</style>
